export default {
	GET_LABELS: "GET_LABELS",
	UPDATE_LABEL: "UPDATE_LABEL",
	RESET_LABELS: "RESET_LABELS",
	ADD_LABEL: "ADD_LABEL"
};
